export const getEscalationStyles = ({ theme, language, screenSize, spacing, fonts }) => ({
    container: {
        direction: language === "ar" ? "rtl" : "ltr",
    },
    header: {
        background: theme === "dark" ? "rgba(255,255,255,0.02)" : "rgba(255,255,255,0.9)",
        border: theme === "dark"
            ? "1px solid rgba(255,255,255,0.15)"
            : "1px solid rgba(0,0,0,0.05)",
        borderRadius: screenSize === "xs" ? "1rem" : "1.5rem",
        padding: spacing.padding,
        marginBottom: spacing.margin,
        boxShadow: theme === "dark"
            ? "0 0.5rem 2rem rgba(0,0,0,0.3)"
            : "0 0.5rem 2rem rgba(0,0,0,0.1)",
    },
    title: {
        color: theme === "dark" ? "white" : "#1a1a1a",
        fontSize: "28px",
        fontWeight: "700",
        margin: 0,
        marginBottom: "0.5rem",
        display: "flex",
        alignItems: "center",
        gap: "0.75rem",
    },
    subtitle: {
        color: theme === "dark" ? "rgba(255, 255, 255, 0.8)" : "rgba(26, 26, 26, 0.7)",
        fontSize: fonts.subtitle,
        margin: 0,
    },
    infoBox: {
        background: theme === "dark"
            ? "rgba(59, 130, 246, 0.1)"
            : "rgba(59, 130, 246, 0.05)",
        border: "1px solid rgba(59, 130, 246, 0.2)",
        borderRadius: "0.75rem",
        padding: spacing.padding,
        marginBottom: spacing.margin,
        display: "flex",
        alignItems: "flex-start",
        gap: "0.75rem",
    },
    formCard: {
        background: theme === "dark" ? "rgba(255,255,255,0.02)" : "rgba(255,255,255,0.9)",
        border: theme === "dark"
            ? "1px solid rgba(255,255,255,0.15)"
            : "1px solid rgba(0,0,0,0.05)",
        borderRadius: screenSize === "xs" ? "1rem" : "1.5rem",
        padding: screenSize === "xs" ? "1.5rem" : "2rem",
        boxShadow: theme === "dark"
            ? "0 0.5rem 2rem rgba(0,0,0,0.3)"
            : "0 0.5rem 2rem rgba(0,0,0,0.1)",
    },
    formGrid: {
        display: "grid",
        gridTemplateColumns: screenSize === "xs"
            ? "1fr"
            : screenSize === "sm"
                ? "1fr"
                : "repeat(2, 1fr)",
        gap: spacing.gap,
        marginBottom: spacing.margin,
    },
    formGroup: {
        marginBottom: spacing.margin,
    },
    formLabel: {
        display: "block",
        color: theme === "dark" ? "rgba(255, 255, 255, 0.8)" : "rgba(26, 26, 26, 0.7)",
        fontSize: fonts.body,
        fontWeight: "500",
        marginBottom: "0.5rem",
    },
    errorText: {
        color: "#ef4444",
        fontSize: fonts.small,
        marginTop: "0.25rem",
        display: "block",
    },
    groupOption: {
        padding: "0.5rem",
        display: "flex",
        flexDirection: "column",
        gap: "0.25rem",
    },
    groupInfo: {
        fontSize: fonts.tiny,
        opacity: 0.7,
    },
    buttonGroup: {
        display: "grid",
        gridTemplateColumns: screenSize === "xs" ? "1fr" : "1fr 1fr",
        gap: spacing.gap,
        marginTop: spacing.margin,
    },
    submitBtn: {
        background: "linear-gradient(135deg, #2e7cba 0%, #1e5a8e 100%)",
        color: "white",
        border: "none",
        padding: screenSize === "xs" ? "0.75rem 1.5rem" : "0.875rem 2rem",
        borderRadius: "0.75rem",
        cursor: "pointer",
        fontSize: fonts.body,
        fontWeight: "600",
        transition: "all 0.3s ease",
        boxShadow: "0 0.25rem 0.75rem rgba(46, 124, 186, 0.3)",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "0.5rem",
    },
    cancelBtn: {
        background: theme === "dark" ? "rgba(255, 255, 255, 0.1)" : "rgba(0, 0, 0, 0.05)",
        color: theme === "dark" ? "white" : "#1a1a1a",
        border: theme === "dark"
            ? "1px solid rgba(255, 255, 255, 0.2)"
            : "1px solid rgba(0, 0, 0, 0.1)",
        padding: screenSize === "xs" ? "0.75rem 1.5rem" : "0.875rem 2rem",
        borderRadius: "0.75rem",
        cursor: "pointer",
        fontSize: fonts.body,
        fontWeight: "600",
        transition: "all 0.3s ease",
        width: "100%",
    },
    emptyState: {
        textAlign: "center",
        padding: screenSize === "xs" ? "3rem 1rem" : "4rem 2rem",
        color: theme === "dark" ? "rgba(255, 255, 255, 0.5)" : "rgba(26, 26, 26, 0.5)",
    },
    previewCard: {
        background: theme === "dark"
            ? "rgba(34, 197, 94, 0.1)"
            : "rgba(34, 197, 94, 0.05)",
        border: "1px solid rgba(34, 197, 94, 0.2)",
        borderRadius: "0.75rem",
        padding: spacing.padding,
        marginTop: spacing.margin,
    },
    mappingFlow: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
        gap: spacing.gap,
    },
    flowItem: {
        flex: 1,
        minWidth: screenSize === "xs" ? "100%" : "150px",
        background: theme === "dark" ? "rgba(255,255,255,0.05)" : "rgba(255,255,255,0.9)",
        padding: "1rem",
        borderRadius: "0.75rem",
        border: theme === "dark"
            ? "1px solid rgba(255,255,255,0.1)"
            : "1px solid rgba(0,0,0,0.1)",
    },
    flowArrow: {
        color: "#2e7cba",
        display: screenSize === "xs" ? "none" : "block",
    },
});